/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT-0
 */
import { INavData } from './models';

export const navItems: INavData[] = [
  {
    name: 'NAV.DASHBOARD',
    url: '/products/dashboard-list',
    icon: 'insights',
    entitlementAction: 'ui.product.nav.dashboard_list',
  },
  {
    name: 'NAV.COST_LIST',
    url: '/products/dashboard-procurement',
    icon: 'attach_money',
    entitlementAction: 'ui.product.nav.dashboard_procurement',
  },
  {
    name: 'NAV.VIRTUAL',
    url: '/products/list/V',
    icon: 'cloud',
    entitlementAction: 'ui.product.screen.virtual',
  },
  {
    name: 'NAV.MATERIALS',
    url: '/products/list/M',
    icon: 'sell',
    entitlementAction: 'ui.product.screen.materials',
  },
  {
    name: 'NAV.RECIPES',
    url: '/products/list/R',
    icon: 'receipt_long',
    entitlementAction: 'ui.product.screen.recipes',
  },
  {
    name: 'NAV.DISHES',
    url: '/products/list/D',
    icon: 'restaurant',
    entitlementAction: 'ui.product.screen.dishes',
  },
  {
    name: 'NAV.COMBINATIONS',
    url: '/products/list/C',
    icon: 'join',
    entitlementAction: 'ui.product.screen.combinations',
  },
  {
    name: 'NAV.PENDING_POS',
    url: '/products/list/P',
    icon: 'pending_actions',
    entitlementAction: 'ui.product.screen.pending_pos',
  },
  {
    name: 'NAV.THROWINGS',
    url: '/products/list/T',
    icon: 'delete_sweep',
    entitlementAction: 'ui.product.screen.throwings',
  },
  {
    name: 'NAV.INVENTORY',
    url: '/products/list/I',
    icon: 'shelves',
    entitlementAction: 'ui.product.screen.inventory',
  },
  {
    name: 'NAV.DOCUMENTS',
    url: '/documents/list',
    icon: 'description',
    entitlementAction: 'ui.document.nav.list',
  },
  {
    name: 'NAV.PENDING_DOCUMENTS',
    url: '/documents/pending',
    icon: 'hourglass_empty',
    entitlementAction: 'ui.document.nav.pending',
  },
  {
    name: 'NAV.REPORTINGS',
    url: '/reportings/list',
    icon: 'campaign',
    entitlementAction: 'ui.report.nav.list',
  },
  {
    name: 'NAV.BUDGET',
    url: '/budget',
    icon: 'calendar_month',
    entitlementAction: 'ui.budget.nav',
  },
  {
    name: 'NAV.SUPPLIERS',
    url: '/suppliers/list',
    icon: 'local_shipping',
    entitlementAction: 'ui.supplier.nav.list',
  },
  {
    name: 'NAV.AI_CHAT',
    url: '/chat/main',
    icon: 'smart_toy',
    entitlementAction: 'ui.chat.nav',
  },
];
